import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Divider,
  Flex,
  Icon,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { GoChevronRight } from 'react-icons/go';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import ModalApprovePendaftar from '../../../../../components/Admin/ModalPengetahuan/ModalApprovePendaftar';
import ModalRejectPendaftar from '../../../../../components/Admin/ModalPengetahuan/ModalRejectPendaftar';
import SidebarWithHeader from '../../../../../components/Admin/SidebarWithHeader';
import Loader from '../../../../../components/Loader';
import ManajemenPengetahuanPendaftarDetailController, {
  useManajemenPengetahuanPendaftarDetailContext,
} from '../../../../../controller/admin/manajemen_pengetahuan/pendaftar/detail';
import { ToastContainer } from 'react-toastify';
import { useRole } from '../../../../../../hooks/useRole';

const DetailPendaftar = () => {
  const { canMutate } = useRole();
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams() as { id: string };
  const { pengetahuan_id } = useParams() as { pengetahuan_id: string };

  const {
    nip,
    nama,
    jabatan,
    pangkat,
    golongan,
    jenisUser,
    judulPengetahuan,
    listData,
    isLoadingFetchData,
    page,
    perPage,
    jumlahData,
    is_approved,
    reason_reject,
  } = useManajemenPengetahuanPendaftarDetailContext().state;

  const { getDetailPengetahuanPendaftar, setPengetahuanPendaftarDetail } =
    useManajemenPengetahuanPendaftarDetailContext().dispatch;

  const columns = [
    {
      name: 'NO.',
      selector: (row, index) => (page - 1) * perPage + index + 1,
      width: '100px',
    },
    {
      name: 'NAMA JUDUL PELATIHAN',
      selector: (row) => row?.judul_pelatihan,
      sortable: true,
      wrap: true,
    },
    {
      name: 'STATUS',
      selector: (row) => row?.status_pelatihan,
      sortable: true,
      wrap: true,
      width: '250px',
      cell: (row) => {
        const status = row?.status_pelatihan;
        let text = '';
        let color = '';

        if (status === null) {
          text = 'Belum Dipelajari';
          color = 'red';
        } else if (status === 'sedang mengikuti') {
          text = 'Sedang Mengikuti';
          color = 'orange';
        } else if (status === 'selesai dipelajari') {
          text = 'Selesai Dipelajari';
          color = 'green';
        }

        return <span style={{ color }}>{text}</span>;
      },
    },
  ];

  useEffect(() => {
    getDetailPengetahuanPendaftar(Number(id), Number(pengetahuan_id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, pengetahuan_id]);

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#F2FFFB',
        fontWeight: '900',
        fontSize: '13px',
      },
    },
  };

  const handlePerRowsChangePengajuan = async (newPerPage, page) => {
    setPengetahuanPendaftarDetail('page', page);
    setPengetahuanPendaftarDetail('perPage', newPerPage);
  };

  const handlePageChangePengajuan = (page) => {
    setPengetahuanPendaftarDetail('page', page);
  };

  return (
    <SidebarWithHeader spacing={false}>
      <Box m={4} pb={4}>
        <Breadcrumb
          spacing="8px"
          mb={4}
          separator={<Icon as={GoChevronRight} color="gray.500" />}
        >
          <BreadcrumbItem>
            <BreadcrumbLink href="/admin/manajemen_pengetahuan/">
              Pengetahuan
            </BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbItem>
            {judulPengetahuan && (
              <>
                <BreadcrumbLink
                  href={'/admin/manajemen_pengetahuan/' + pengetahuan_id}
                >
                  {judulPengetahuan}
                </BreadcrumbLink>
              </>
            )}
          </BreadcrumbItem>

          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink>Pendaftar</BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink href={location.pathname}>
              Detail Pendaftar
            </BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>

        <Button
          leftIcon={<AiOutlineArrowLeft />}
          color="black"
          bg="white"
          _hover={{ bg: 'white' }}
          _active={{ bg: 'white' }}
          onClick={() =>
            history.push('/admin/manajemen_pengetahuan/' + pengetahuan_id)
          }
        >
          Kembali
        </Button>

        {is_approved === false && (
          <>
            <Alert status="error" mt={4} borderRadius="lg">
              <Flex>
                <AlertIcon />
                <Box>
                  <AlertTitle fontWeight={'normal'}>
                    Pengajuan Verifikasi ditolak.
                  </AlertTitle>
                  <AlertDescription>
                    <b>Alasan Ditolak: </b> {reason_reject}
                  </AlertDescription>
                </Box>
              </Flex>
            </Alert>
          </>
        )}
        <Box mt={4} bg="white" borderRadius="md">
          <SimpleGrid p={6} columns={{ base: 2, md: 3 }} spacing={4}>
            <Box>
              <Box fontWeight="bold" mb={2}>
                NIP/NIK
              </Box>
              <Box>{nip ?? '-'}</Box>
            </Box>
            <Box>
              <Box fontWeight="bold" mb={2}>
                Nama
              </Box>
              <Box>{nama ?? '-'}</Box>
            </Box>
            <Box>
              <Box fontWeight="bold" mb={2}>
                Jabatan
              </Box>
              <Box>{jabatan ?? '-'}</Box>
            </Box>
            {jenisUser === 1 && (
              <>
                <Box>
                  <Box fontWeight="bold" mb={2}>
                    Pangkat
                  </Box>
                  <Box>{pangkat ?? '-'}</Box>
                </Box>
                <Box>
                  <Box fontWeight="bold" mb={2}>
                    Golongan
                  </Box>
                  <Box>{golongan ?? '-'}</Box>
                </Box>
              </>
            )}
          </SimpleGrid>
          <Divider />
          <Box p={6}>
            <Text fontWeight="bold" fontSize="base">
              Pelatihan Relevan
            </Text>
            <DataTable
              data={listData}
              columns={columns}
              customStyles={customStyles}
              pagination
              paginationServer
              onChangeRowsPerPage={handlePerRowsChangePengajuan}
              onChangePage={handlePageChangePengajuan}
              paginationTotalRows={listData.length > 0 ? jumlahData : 0}
              progressPending={isLoadingFetchData}
              progressComponent={<Loader />}
              noDataComponent="Tidak ada data"
            />
            {canMutate && (
              <Flex justify="flex-end" mt={4} gap={3}>
                {is_approved === false ? (
                  <>
                    <ModalApprovePendaftar
                      pengetahuan_id={pengetahuan_id}
                      id={id}
                      mode="revisi"
                    />
                  </>
                ) : (
                  <>
                    <ModalRejectPendaftar
                      pengetahuan_id={pengetahuan_id}
                      id={id}
                    />
                    <ModalApprovePendaftar
                      pengetahuan_id={pengetahuan_id}
                      id={id}
                      mode="approve"
                    />
                  </>
                )}
              </Flex>
            )}
          </Box>
        </Box>
      </Box>
    </SidebarWithHeader>
  );
};

const DetailPendaftarWrapper = () => {
  return (
    <ManajemenPengetahuanPendaftarDetailController.Provider>
      <ToastContainer
        position="top-center"
        style={{ width: '60%', marginTop: '5%' }}
      />
      <DetailPendaftar />
    </ManajemenPengetahuanPendaftarDetailController.Provider>
  );
};

export default DetailPendaftarWrapper;
